import { ReactElement } from 'react';
import { onImageError } from '@helper/utils';
import { usePRecommendationKAEQuery } from '@services/hooks/contractor360KAE/usePRecommendationKAEQuery';
import { useLocation } from 'react-router-dom';
import { Wrapper } from '@components/common/Wrapper/wrapper';
import { NoDataFound } from '@components/common/no-data-found/noDataFound';

export const ProductRecommendedInfo = (): ReactElement => {
	const { state } = useLocation();

	const {
		isFetching: isPRecommendedDataFetching,
		data: pRecommendedData,
		error: pRecommendedDataError,
	} = usePRecommendationKAEQuery(state?.siteId);
	const products = pRecommendedData?.products;
	// Handle feedback as array since API returns array but type definition expects object
	const productFeedback = Array.isArray(pRecommendedData?.feedback)
		? pRecommendedData.feedback[0]
		: pRecommendedData?.feedback;
	const productFeedbackList = [
		{
			question_type: 'product_feedback',
			question: 'Product Feedback',
			answer: productFeedback?.bde_feedback || '-',
		},
		{
			question_type: 'product_feedback',
			question: 'Any Feedback',
			answer: productFeedback?.any_feedback || '-',
		},
	];

	return (
		<div className="p-recommended-info-section">
			<div className="title-with-line">Products recommended</div>

			<Wrapper isLoaderVisible={isPRecommendedDataFetching} isError={pRecommendedDataError}>
				<ul className="row">
					{products && products.length > 0 ? (
						products.map((p) => (
							<li key={p.product_code} className="d-col d-col-2">
								<div className="product-discussion-card" id="product-popup">
									<div className="product-image">
										<img
											role="presentation"
											src={p.image}
											alt={p.product_code}
											width="104"
											height="156"
											onError={onImageError}
										/>
									</div>

									<div className="product-details">
										<span className="h3">{p.product_code}</span>
										<span className="p-tag h4">{p.product_demo ? 'Demo: Yes' : 'Discussed: Yes'}</span>
									</div>
								</div>
							</li>
						))
					) : (
						<NoDataFound message="No Data Found!" />
					)}
				</ul>

				<div className="bde-feedback">
					<div className="title-with-line">BDE Feedback</div>

					<ul className="row">
						{productFeedbackList.map((item) => (
							<li key={item.question} className="d-col d-col-2">
								<div className="product-discussion-card" id="product-popup">
									<div className="product-details">
										<span className="h3">{item.question}</span>
										<p className="feedback-comment">{item.answer}</p>
									</div>
								</div>
							</li>
						))}
					</ul>
				</div>
			</Wrapper>
		</div>
	);
};
